import { put, select } from "redux-saga/effects";

import type { ApplyEventsSearchCriteriaAction } from "domains/events/actionTypes";
import { getEventsSearchCriteria } from "domains/events/selectors";
import { getTmSelectedId } from "domains/transformationMap/selectors";
import { fetchEventsForTopic } from "entities/events/actions";

export function* applyEventsSearchCriteriaSaga(action: ApplyEventsSearchCriteriaAction) {
  const searchCriteria: ReturnType<typeof getEventsSearchCriteria> = yield select(getEventsSearchCriteria);
  const transformationMapSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  const id = action.payload.topicId ?? transformationMapSelectedId;
  if (id !== undefined) yield put(fetchEventsForTopic({ id, ...searchCriteria }));
}
